export default __webpack_public_path__ + "static/media/checkmark_white.c1f3baff.svg";